import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = {add_org_mandate_loading : true, add_org_mandate: '', add_org_mandate_error: false};

export function addOrgMandate(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_ORG_MANDATE:
        return {
            add_org_mandate_loading: true,
            add_org_mandate: '',
            add_org_mandate_error: false
        };
      case organisationConstants.RESPONSE_ORG_MANDATE:
        return {
            add_org_mandate_loading: false,
            add_org_mandate: action.add_org_mandate,
            add_org_mandate_error: false
        };
      case organisationConstants.ERROR_ORG_MANDATE:
        return { 
            add_org_mandate_loading: false,
            add_org_mandate: '',
            add_org_mandate_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/addOrgMandate.reducer.js